import type React from 'react';
import { useCallback } from 'react';
import type { OnCommitStageSettings } from '../types';
type PropsT = {
  stageRef: React.RefObject<HTMLDivElement>;
  containerRef: React.RefObject<HTMLDivElement>;
  onCommitStageSettingsAndApplyToDOMNodes: OnCommitStageSettings;
};
export function useFitToScreen({
  stageRef,
  containerRef,
  onCommitStageSettingsAndApplyToDOMNodes
}: PropsT) {
  return useCallback(() => {
    if (!stageRef.current || !containerRef.current) {
      return;
    }
    const stageElement = stageRef.current;
    const containerElement = containerRef.current;
    const {
      clientWidth,
      clientHeight
    } = stageElement;
    const {
      clientWidth: containerWidth,
      clientHeight: containerHeight,
      offsetWidth: containerOffsetWidth,
      offsetHeight: containerOffsetHeight
    } = containerElement;
    const diffWidth = containerOffsetWidth / 2 - clientWidth / 2;
    const diffHeight = containerOffsetHeight / 2 - clientHeight / 2;
    const updatedScale = Math.min(containerWidth / clientWidth, containerHeight / clientHeight);
    onCommitStageSettingsAndApplyToDOMNodes({
      scale: updatedScale,
      x: diffWidth,
      y: diffHeight
    });
  }, [stageRef, containerRef, onCommitStageSettingsAndApplyToDOMNodes]);
}